/* src/app/pages/ui-kit/components/stepper-view/stepper-view.component.scss */
.demo {
  padding: 16px 0;
}
/*# sourceMappingURL=stepper-view.component.css.map */
